import { render, staticRenderFns } from "./loanDetailComponent.vue?vue&type=template&id=417c2d8f&"
import script from "./loanDetailComponent.vue?vue&type=script&lang=js&"
export * from "./loanDetailComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports